import { Directive, OnInit, HostListener } from '@angular/core';
import { IonInput, IonSelect, IonModal } from '@ionic/angular';

type IonicElement = IonSelect | IonInput | IonModal;

@Directive({
  selector: '[appAdvanceInputOnEnter]',
})
export class AdvanceInputOnEnterDirective implements OnInit {

  constructor() {}

  ngOnInit() {
  }

  @HostListener('keyup.enter', ['$event'])
  onEnterKeyPress(event: KeyboardEvent) {
    this.updateFocus(event);
  } 

  private updateFocus(event: KeyboardEvent) {
    const target = event.currentTarget as any;
    const form: Element = (event.currentTarget as Element).closest('form'); // Want to limit to current form
    const nodeList = form.querySelectorAll('[appAdvanceInputOnEnter]') as any;

    let target_idx = -1;
    for (let i = 0; i < nodeList.length - 1; i++) { // length - 1 here to prevent trying to focus on non-existent element after last
      if (nodeList[i] === target) {
        target_idx = i;
        break;
      }
    }

    for (let j = target_idx + 1; 0 < j && j < nodeList.length; j++) {
      const nextElement = nodeList[j];
      const nodeName: string = (nodeList[j] as any).nodeName;
      if (nodeName === 'ION-INPUT') {
        (nextElement as IonInput).setFocus();
        break;
      } else if (nodeName === 'ION-SELECT') {
        (nextElement as IonSelect).open();
        break;
      } else if (nodeName === 'ION-DATETIME') {
        (nextElement.parentNode.parentNode as any as IonModal).present();
        break;
      }
    }
  }
}
